import React from "react";
import { Popover } from ".";

/** Properties expected by TutorialDisplay.
 * @param {number} tutorialState - The current state of the tutorial.
 * @param {boolean} isProgressDisabled - Determine what instruction to give the player depending on whether or not progress is disabled.
 * @param {function} onPopoverClicked - Callback for when a popover is clicked.
*/
interface TutorialProps {
    tutorialState: number
    isProgressDisabled: boolean
    onPopoverClicked: () => void
}

/** Determine the visibilty and position of the tutorial popovers depending on the parent tutorial state. */
export const TutorialDisplay = (props: TutorialProps) => {
    const { tutorialState, isProgressDisabled, onPopoverClicked } = props;
    const leftMargin = "auto auto auto 20px";
    const rightMargin = "auto 20px auto auto";
    
    switch (tutorialState) {
        case 0:
            return (
                <Popover 
                content={`${isProgressDisabled ? "Click a choice above or click the arrows to select a choice. Click the selected choice again or the center arrow to confirm." 
                    : "Tap the lungs to to show more text."}`} 
                arrowPosition={"center"}
                onPopoverClicked={onPopoverClicked}/>
            );
        case 1:
            return (
                <Popover content={"Throughout the game, you will notice that certain activities will cause your energy levels to go down."} 
                arrowPosition={"left"} 
                marginOrientation={leftMargin}
                onPopoverClicked={onPopoverClicked}/>);
        case 2:
            return (
                <Popover 
                content={"If you need a reminder of what to do or if you’d like to start over, you can click on the menu icon."} 
                arrowPosition={"right"} 
                marginOrientation={rightMargin}
                onPopoverClicked={onPopoverClicked}/>);
        case 3:
            return (
                <Popover 
                content={"When you’re ready, press the lungs icon."} 
                arrowPosition={"none"}
                onPopoverClicked={onPopoverClicked}/>);
        default:
            return (<></>);
    }
}